export default {
  namespaced: true,
  state: {
    sidebar: localStorage.sidebar ? localStorage.sidebar : false,
    load: false
  },
  mutations: {
    setSidebar(state, payload) {
      localStorage.sidebar = payload;
      state.sidebar = payload;
    },
    setLoad(state, payload) {
      state.load = payload;
    }
  },
}
